var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import fontAwesomeIcons from './fontAwesomeIconStyles';
import { callable } from '../../../../lib';
import { fittedStyle } from '../../../../styles/customCSS';
import { pxToRem } from '../../utils';
import { getStyle as getSvgStyle } from './svg';
var sizes = {
    smallest: 7,
    smaller: 10,
    small: 12,
    medium: 16,
    large: 20,
    larger: 32,
    largest: 40,
};
var getDefaultFontIcon = function (iconName) {
    return callable(fontAwesomeIcons(iconName).icon)();
};
var getFontStyles = function (size, iconName, themeIcon) {
    var _a = themeIcon || getDefaultFontIcon(iconName), fontFamily = _a.fontFamily, content = _a.content;
    var sizeInRems = pxToRem(size);
    return {
        fontFamily: fontFamily,
        fontSize: sizeInRems,
        lineHeight: 1,
        textAlign: 'center',
        '::before': {
            content: content,
            display: 'block',
            width: sizeInRems,
            height: sizeInRems,
        },
    };
};
var getXSpacingStyles = function (xSpacing, horizontalSpace) {
    switch (xSpacing) {
        case 'none':
            return fittedStyle;
        case 'before':
            return __assign({}, fittedStyle, { marginLeft: horizontalSpace });
        case 'after':
            return __assign({}, fittedStyle, { marginRight: horizontalSpace });
        case 'both':
            return __assign({}, fittedStyle, { margin: "0 " + horizontalSpace });
    }
};
var getBorderedStyles = function (circular, boxShadowColor) {
    return __assign({}, getPaddedStyle(), { boxShadow: "0 0 0 .05rem " + boxShadowColor + " inset" }, (circular ? { borderRadius: '50%' } : {}));
};
var getPaddedStyle = function () { return ({
    padding: pxToRem(4),
}); };
var getIconSize = function (size, sizeModifier) {
    if (!sizeModifier) {
        return sizes[size];
    }
    var modifiedSizes = {
        large: {
            x: 24,
            xx: 28,
        },
    };
    return modifiedSizes[size] && modifiedSizes[size][sizeModifier];
};
var getIconColor = function (colorProp, variables) {
    return _.get(variables.colors, colorProp, variables.color || 'currentColor');
};
var iconStyles = {
    root: function (_a) {
        var _b = _a.props, disabled = _b.disabled, name = _b.name, size = _b.size, bordered = _b.bordered, circular = _b.circular, color = _b.color, xSpacing = _b.xSpacing, v = _a.variables, theme = _a.theme;
        var iconSpec = theme.icons[name];
        var isFontBased = !iconSpec || !iconSpec.isSvg;
        return __assign({ backgroundColor: v.backgroundColor, display: 'inline-block', margin: v.margin, speak: 'none', verticalAlign: 'middle' }, (isFontBased && getFontStyles(getIconSize(size, v.sizeModifier), name)), (isFontBased && __assign({ color: getIconColor(color, v) }, (disabled && {
            color: v.disabledColor,
        }))), getXSpacingStyles(xSpacing, v.horizontalSpace), ((bordered || v.borderColor || circular) &&
            getBorderedStyles(circular, v.borderColor || getIconColor(color, v))));
    },
    outlinePart: function (_a) {
        var v = _a.variables;
        return __assign({ display: 'none' }, (v.outline && {
            display: 'block',
        }));
    },
    filledPart: function (_a) {
        var v = _a.variables;
        return __assign({}, (v.outline && {
            display: 'none',
        }));
    },
    svg: function (_a) {
        var _b = _a.props, size = _b.size, color = _b.color, disabled = _b.disabled, v = _a.variables;
        var iconSizeInRems = pxToRem(getIconSize(size, v.sizeModifier));
        return __assign({ display: 'block', width: iconSizeInRems, height: iconSizeInRems, fill: getIconColor(color, v) }, (disabled && {
            fill: v.disabledColor,
        }), getSvgStyle('svg'));
    },
    g: getSvgStyle('g'),
    path: getSvgStyle('path'),
    secondaryPath: getSvgStyle('secondaryPath'),
};
export default iconStyles;
